<template>
  <section
    v-if="acknowledgement"
    class="current-acknowledgement-section"
  >
    <div class="d-flex align-center">
      <div class="text-h2 section-title mr-2">
        Current Job Profile Acknowledgement
      </div>
      <EmployeeAcknowledgementStatusPill
        :status-key="acknowledgementStatusKey(acknowledgement.status)"
        :label="acknowledgementStatusLabel(acknowledgement.status)"
      />
    </div>
    <div class="current-info-grid text-body-2 text-textLight">
      <span class="current-info-label text-textDark font-weight-bold">Job Profile Title</span>
      <span>{{ acknowledgement.title || '—' }}</span>
      <span class="current-info-label text-textDark font-weight-bold">Job Code</span>
      <span>{{ acknowledgement.hris_job_code || '—' }}</span>
      <span class="current-info-label text-textDark font-weight-bold">Created At</span>
      <span>{{ formatDisplayDate(acknowledgement.created_at) }}</span>
      <template v-if="acknowledgement.signed_at">
        <span class="current-info-label text-textDark font-weight-bold">Finalized At</span>
        <span>{{ formatDisplayDate(acknowledgement.signed_at) }}</span>
      </template>
    </div>
  </section>
</template>

<script setup>
import EmployeeAcknowledgementStatusPill
  from '@/components/library/employeeAcknowledgements/EmployeeAcknowledgementStatusPill.vue';
import { formatDisplayDate } from '@/helpers/date';
import {
  acknowledgementStatusKey,
  acknowledgementStatusLabel,
} from '@/components/library/employeeAcknowledgements/helpers';

defineProps({
  acknowledgement: {
    type: Object,
    default: null,
  },
});

</script>

<style scoped lang="less">
.current-acknowledgement-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 24px;

  .section-title {
    margin-bottom: 4px;
  }

  .current-info-grid {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 16px;
    row-gap: 4px;
    line-height: 1.5;
  }

  .current-info-label {
    white-space: nowrap;
  }
}
</style>
